import { Component, OnInit, ViewChild } from '@angular/core';
import { IonModal, ModalController, Platform } from '@ionic/angular';
import { divIcon, icon, LeafletEventHandlerFn, Map, marker, tileLayer, latLng, latLngBounds } from 'leaflet';
import { ContentService } from '../../services/content.service';
import { PlaceEventsComponent } from '../../modals/place-events/place-events.component';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { LocationAccuracy } from '@awesome-cordova-plugins/location-accuracy/ngx';
import { ActivatedRoute } from '@angular/router';
import { GetContentsRequest } from 'src/app/models/getContentsRequest';
import { Schedule } from '../../models/contentResults';
import { AppConfig } from '../../services/app-config.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.page.html',
  styleUrls: ['./map.page.scss'],
})
export class MapPage implements OnInit {

  @ViewChild(IonModal) modalFilters: IonModal;
  
  map: Map;

  pageTitle = 'Mapa de lugares';

  // Resultados
  results = [];

  // Filtros
  filtro:number ;
  filtroName = 'Bienestar';
  filtroLugar = null;
  placeTags = [];
  ResultsPlaces = [];
  tagName = '';
  bePlaces = false;

  constructor(
    private contentService: ContentService,
    private modalCtrl: ModalController,
    private geolocation: Geolocation,
    private locationAccuracy: LocationAccuracy,
    private activatedRoute: ActivatedRoute,
    private platform: Platform,
    private appConfig: AppConfig
  ) { }

  ngOnInit() {}

  ionViewDidEnter() {

    this.filtroName = 'Bienestar';

    this.activatedRoute.params.subscribe( params => {
      // console.log( params );

      params.txtSearch ? this.pageTitle = 'Resultados de busqueda' : null;
      params.contentTypeId ? this.filtro = parseInt(params.contentTypeId) : this.filtro = this.appConfig.getConfig('bienestar_id');

      // console.log( this.filtro )
      if ( params.txtSearch && params.type === 'place') {
        // console.log('hacer busqueda de places');
        this.nullFilters();
        this.searchLikePlace( params.txtSearch );

      } else if ( params.txtSearch && params.type === 'content') {
        // console.log('hacer busqueda de content')
        this.nullFilters()
        this.searchContentPlace(params.txtSearch);
      } else {
        this.searchPlace(this.appConfig.getConfig('bienestar_id'), null);
      }

      this.contentService.getPlaceTag()
          .subscribe ( (placeTags: any) => {
            // console.log(placeTags)
            this.placeTags = placeTags;
            this.getPlacesTypes(this.appConfig.getConfig('bienestar_id'), 'Bienestar')
          })

    });

     
  }

  ionViewWillLeave() {
    this.map.remove();
  }

  loadMap() {

    const reference = this;
    // Separo los places
    let places = [];
    // this.results.forEach( result => {
    //   result.schedules.forEach( schedule => {
    //       places.push( schedule.place )
    //   })
    // })
    // console.log(places);

    const southWest = latLng(-55.512610049084024, -77.36731371074818);
    const northEast = latLng(-20.403397914858488, -52.61326259555444);
    const bounds = latLngBounds(southWest, northEast);
    
    this.map = new Map('mapIdBienestar', {zoomControl: false, keyboard: false, maxBounds: bounds  }).setView([-34.603032427989, -58.38137728258387], 12);
    this.map.options.minZoom = 6;
    tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);


    var greenIcon = icon({
      iconUrl: 'assets/map/bxs-map.png',
      // shadowUrl: 'leaf-shadow.png',
  
      iconSize:     [38, 95], // size of the icon
      // shadowSize:   [50, 64], // size of the shadow
      // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
      // shadowAnchor: [4, 62],  // the same for the shadow
      popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
    });

    this.geolocation.getCurrentPosition().then( (resp) => {
      marker([resp.coords.latitude, resp.coords.longitude],{icon: icon({iconUrl: 'assets/icon/ubicacionActual.svg', iconSize: [24,30], iconAnchor: [12,30], popupAnchor: [0,0], tooltipAnchor: [0,0]}) }).addTo(this.map);
    })
    
    this.results.forEach( place => {
      // console.log(place)

      const myIcon = place.type ? 
                     divIcon({className: 'div-icon', html: '<img src="'+place.type.iconUrl+'"/>'}) :
                     divIcon({className: 'div-icon', html: '<img src="/assets/icon/placeDefault.svg"/>'});
      marker([place.lat, place.lon], {icon: myIcon})
          .addTo(this.map).on('click', function(e) {
            console.log(place.id);
            reference.openModal(place.id);
        });
    })
    // var customMarker  = marker([-34.603032427989, -58.38137728258387],{icon: icon({iconUrl: 'assets/map/bxs-map.png', iconSize: [24,30], iconAnchor: [12,30], popupAnchor: [0,0], tooltipAnchor: [0,0]}) }).addTo(this.map);
  }

  searchPlace( tagId, placeTypeId ) {
    this.contentService.searchPlace( tagId, placeTypeId )
    .subscribe( (resp: any[]) => {
      console.log( resp )
      this.results = resp;
      this.loadMap();
    })
  }

  searchLikePlace( text: string ){
    this.contentService.searchLikePlace( text )
          .subscribe ( (resp:any[]) => {
            console.log( resp );
            this.results = resp;
            this.loadMap();
          })
  }

  searchContentPlace( text: string ) {
      this.contentService.getContents({
        text,
        limit: 1000,
        offset: 1
      } as GetContentsRequest)
      .subscribe ( (resp:any[]) => {
        console.log( resp );

        resp.forEach( (content: any) => {

          content.schedules.forEach( (schedule: Schedule) => {
            this.results.push( schedule.place )
          });

        })

        this.loadMap();
      });
  }

  async openModal(placeId) {
    const modal = await this.modalCtrl.create({
      component: PlaceEventsComponent,
      cssClass: 'transparent-modal-place',
      componentProps: {
        placeId,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      console.log(data)
      // this.dapartmentId = data;
    }
  }

  async openFilterModal() {
    this.modalFilters.present();
  }

  zoomIn() {
    const newZoom = this.map.getZoom() + 1;
    this.map.setZoom(newZoom);
  }

  zoomOut() {
    const newZoom = this.map.getZoom() - 1;
    this.map.setZoom(newZoom);
  }

  getPlacesTypes(filtro: any, tagName?: string) {
    this.contentService.getPlaceType( filtro )
            .subscribe( (resp: any) => {
              console.log(resp)
              this.ResultsPlaces = resp;
              this.tagName = tagName
              this.bePlaces = true;
              this.filtroLugar = null;
            })
  }

  changeFilter( type: number, filtro: any, tagName?: string ) {
    // console.log( type )
    switch (type) {
      case 0:
        this.filtro = filtro;
        this.filtroName = tagName;
        this.getPlacesTypes(filtro, tagName)
        
        break;
      case 1:
        this.filtroLugar = filtro
    }
  }

  clearFilters() {
    this.filtro = this.appConfig.getConfig('bienestar_id');
    this.filtroName = 'Bienestar';
    this.filtroLugar = null;
    this.ResultsPlaces = [];
    this.bePlaces = false;
  }

  nullFilters() {
    this.filtro = null;
    this.filtroName = ''
  }

  async filtrar() {
    // await this.searchPlace( this.filtro, this.filtroLugar);
    this.contentService.searchPlace( this.filtro, this.filtroLugar )
    .subscribe( (resp: any[]) => {
      // console.log( resp )
      this.map.remove();
      this.results = resp;
      this.modalFilters.dismiss();

      this.loadMap();
    })
  }

  userLocation() {

    if ( !this.platform.is("hybrid") ) {
      this.geolocation.getCurrentPosition().then( (resp) => {
        this.map.flyTo([resp.coords.latitude, resp.coords.longitude], 13);
      }, error => console.log(error));
      return;
    }
    
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {
      console.log(canRequest)
      if(canRequest) {
        // the accuracy option will be ignored by iOS
        this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
          () => {
            console.log('GPS Request successful');

            this.geolocation.getCurrentPosition().then( (resp) => {
              this.map.flyTo([resp.coords.latitude, resp.coords.longitude], 13);
            }, error => console.log(error));
          },
          error => console.log('GPS Error requesting location permissions', error)
        );
      }
    
    });
  }

  enabledGPS() {
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {

      if(canRequest) {
        // the accuracy option will be ignored by iOS
        this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
          () => console.log('GPS Request successful'),
          error => console.log('GPS Error requesting location permissions', error)
        );
      }
    
    });
  }

}
